import type { AuthorizedResource } from '@/services/bff/permission.api';

export type AuthorizedResourceAccessMap = Record<string, boolean>;

export const isAuthorizedResourceAllowed = (effect?: string | null) =>
  effect === 'ALLOW';

export function buildAuthorizedResourceAccessMap(
  authorizedResources: AuthorizedResource[] = [],
): AuthorizedResourceAccessMap {
  return authorizedResources.reduce<AuthorizedResourceAccessMap>(
    (accumulator, resource) => {
      if (!resource?.code) {
        return accumulator;
      }

      const allowed = isAuthorizedResourceAllowed(resource.effect);
      const actions = resource.actions ?? [];

      accumulator[resource.code] =
        allowed &&
        (actions.length === 0 ||
          actions.includes('view') ||
          actions.includes('manage'));

      if (actions.length === 0) {
        accumulator[`${resource.code}:*`] = allowed;
      }

      actions.forEach((action) => {
        if (action) {
          accumulator[`${resource.code}:${action}`] = allowed;
        }
      });

      return accumulator;
    },
    {},
  );
}
